import script from "./ArticleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleItem.vue?vue&type=script&setup=true&lang=js"

import "./ArticleItem.vue?vue&type=style&index=0&id=18051825&lang=css"

const __exports__ = script;

export default __exports__